<template>
	<CastDetail v-if="detail" :detail="detail" />
</template>
<script>
	import moment from 'moment';
	import CastDetail from '@/components/cast/CastDetail.vue';

	export default {
		name: 'CastModify',
		components: {
			CastDetail,
		},
		data() {
			return {
				detail: undefined,
			};
		},
		methods: {
			async setDetail() {
				try {
					const { data } = await this.$axiosNoah.get(
						`/pouch/${this.$route.params.castId}`
					);
					const createDate = data.createDate.replace(
						/(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/,
						'$1-$2-$3 $4:$5:$6'
					);
					const startDate = data.startDate
						? moment(data.startDate, 'YYYYMMDDHHmmss').format(
								'YYYY-MM-DDTHH:mm'
							)
						: '';
					const bestPeriod =
						data.isBest && data.bestStartOn && data.bestEndOn
							? {
									from: moment(data.bestStartOn, 'x').format(
										'YYYY-MM-DDTHH:mm'
									),
									to: moment(data.bestEndOn, 'x').format(
										'YYYY-MM-DDTHH:mm'
									),
								}
							: { from: '', to: '' };
					const detail = {
						...data,
						createDate,
						startDate,
						bestPeriod,
						imageDto: {
							fileDir: data.fileDir,
							fileSize: data.fileSize,
							fileType: data.fileType,
							fileOrgName: data.fileOrgName,
							fileSaveName: data.fileSaveName,
						},
						etcList: [
							{
								key: 'CastInterestUser',
								value: data.castInterestCount || 0,
								th: '관심캐스트',
							},
							{
								key: 'CastLikeUser',
								value: data.castLikeCount || 0,
								th: '좋아요',
							},
							{
								key: 'CastCommentedUser',
								value: data.commentCnt || 0,
								th: '댓글',
							},
						],
						mainImage: data.mainImage ? [data.mainImage] : null,
					};

					if (data.moduleList) {
						detail.moduleList = JSON.parse(data.moduleList).map(
							module => {
								const parsedModule = { ...module };
								if (module.id === 'pdt') {
									parsedModule.pdtList = module.pdtList.map(
										pdtId => {
											const pdt =
												data.moduleProductsInfo[pdtId];
											return {
												idProduct: pdt.idProduct,
												image: pdt.filePath,
												title: `[${pdt.idProduct}/${pdt.brandTitle}] ${pdt.productTitle}`,
											};
										}
									);
								} else if (module.id === 'txt') {
									parsedModule.conts = decodeURIComponent(
										module.conts
									);
								}
								return parsedModule;
							}
						);
					}

					this.detail = detail;
				} catch (err) {
					console.error(err);
					alert('조회 실패했습니다. 개발팀에 문의하세요.');
				}
			},
		},
		mounted() {
			this.setDetail();
		},
	};
</script>
